import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: JSX.Element; // The component to render if the user is authorized
    roles?: string[]; // Optional: Allowed roles for this route
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
    // Retrieve the token and role from localStorage
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("role");

    // If no token, redirect to login
    if (!token) {
        return <Navigate to="/" />;
    }

    // If roles are specified, check if the user's role is authorized
    if (roles && !roles.includes(userRole || "")) {
        return <Navigate to="/unauthorized" />; // Redirect to an unauthorized page or alternative route
    }

    // User is authenticated and authorized
    return children;
};

export default ProtectedRoute;
